// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import './plugins/vuetify';

import App from './App';
import router from './router';
import { store } from './store';
import { auth } from './firebase';
import { b64DecodeUnicode } from './utils';

Vue.config.productionTip = false;

function initialize() {
  // listen for auth state changes and route user based on the state
  auth.onAuthStateChanged(user => {
    this.$store.commit('setAuthStatus', { authStatusKnown: true });
    if (user) {
      // get idToken and decode it to get user claims
      user.getIdToken().then(idToken => {
        let claimsEncoded = idToken.split('.')[1];
        if (claimsEncoded.includes('-')) {
          claimsEncoded = claimsEncoded.replace('-', '+');
        }
        if (claimsEncoded.includes('_')) {
          claimsEncoded = claimsEncoded.replace('_', '/');
        }
        const userClaims = JSON.parse(b64DecodeUnicode(claimsEncoded));
        const [firstName, lastName] = user.displayName.split(' ');
        const profile = {
          uid: user.uid,
          name: user.displayName,
          firstName,
          lastName,
          email: user.email,
          phone: user.phoneNumber, // TODO: use libphonenumber
          photoUrl: `users/${user.uid}/photos/profile.png`,
          cid: userClaims.cid,
          role: userClaims.role
        };
        this.$store.commit('setProfile', { profile });

        // navigate to respective dashboard based on role
        const { redirect } = this.$router.currentRoute.query;
        // eslint-disable-next-line
        const nextRoute = redirect || `/${profile.role}`;
        this.$router.push(nextRoute);
      });
    } else {
      this.$store.commit('setProfile', { profile: null });
      const { redirect } = this.$router.currentRoute.query;
      // eslint-disable-next-line
      const nextRoute = { path: '/login' };
      if (!/\/login/.test(redirect)) {
        nextRoute.query = {
          redirect
        };
      }

      this.$router.push(nextRoute);
    }
  });
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  created() {
    initialize.call(this);
  },
  template: '<App/>'
});
